var path = '/home/travis/build/orizens/echoes/src/components/now-playing/playlist-saver/playlist-saver.tpl.html';
var html = "<div class=playlist-saver><div class=col-md-12><aside class=title>New Playlist For {{ $ctrl.tracks.length }} Tracks</aside></div><div class=\"col-md-12 text-center\"><input ng-model=$ctrl.playlist.title placeholder=\"Type A Name\" class=col-md-12></div><div class=col-md-12><button class=\"btn btn-xs btn-link\" ng-click=$ctrl.onCancel()>cancel</button> <button class=\"btn btn-xs btn-primary btn-save\" ng-click=$ctrl.save()><span class=\"fa fa-circle-o-notch fa-spin\" ng-show=$ctrl.inSaveMode></span> save</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/now-playing/playlist-saver/playlist-saver.tpl.html
 ** module id = 127
 ** module chunks = 1
 **/